import { Spinner } from 'components/Spinner';
import { classNames } from 'libs/react';
import { useEffect } from 'libs/react';
import { useRef } from 'libs/react';
import { useState } from 'libs/react';
import { Fragment } from 'libs/react';
import { React } from 'libs/react';
import './Waiter.scss';
/**
 * @component Waiter
 * @since 1.0.0
 */
export function Waiter(props) {
    let { style, until, active, opaque, renderWhileLoading, minimumLoadingTime, maximumLoadingTime } = Object.assign({ style: 'normal', active: false, opaque: true, minimumLoadingTime: 500, maximumLoadingTime: 5000, renderWhileLoading: false }, props);
    active = until == null ? active : until == false;
    const timeout = useRef(0);
    const [display, setDisplay] = useState(active);
    const [spinner, setSpinner] = useState(active);
    const [started, setStarted] = useState(Date.now());
    const node = useRef(null);
    /**
     * @function getDisplayDuration
     * @since 1.0.0
     * @hidden
     */
    function getDisplayDuration() {
        return Date.now() - started;
    }
    /**
     * @function getDisplayRetainer
     * @since 1.0.0
     * @hidden
     */
    function getDisplayRetainer() {
        return minimumLoadingTime ? minimumLoadingTime - getDisplayDuration() : 0;
    }
    /**
     * @function getChildren
     * @since 1.0.0
     * @hidden
     */
    function getChildren() {
        return active && renderWhileLoading == false ? null : props.children;
    }
    /**
     * @function onTransitionEnd
     * @since 1.0.0
     * @hidden
     */
    function onTransitionEnd() {
        setSpinner(false);
    }
    useEffect(() => {
        if (node.current) {
            node.current.addEventListener('transitionend', onTransitionEnd);
            node.current.addEventListener('transitioncancel', onTransitionEnd);
        }
        return () => {
            if (node.current) {
                node.current.removeEventListener('transitionend', onTransitionEnd);
                node.current.removeEventListener('transitioncancel', onTransitionEnd);
            }
        };
    }, []);
    useEffect(() => {
        if (timeout.current) {
            timeout.current = clearTimeout(timeout.current);
        }
        if (active) {
            setDisplay(true);
            setSpinner(true);
            setStarted(Date.now());
        }
        else {
            if (minimumLoadingTime) {
                const retains = getDisplayRetainer();
                if (retains > 0) {
                    timeout.current = setTimeout(() => setDisplay(false), retains);
                    return;
                }
            }
            setDisplay(false);
        }
    }, [active]);
    const spinning = spinner || display;
    const children = getChildren();
    const className = classNames('waiter', 'waiter--' + style, { 'waiter--is-active': active }, { 'waiter--is-opaque': opaque }, props.className);
    return (React.createElement(Fragment, null,
        children,
        spinning && (React.createElement("div", { ref: node, className: className },
            React.createElement(Spinner, { style: style })))));
}
